<template>
  <div class="topbar">
    <v-layout row wrap align-center justify-space-between class="page-wrap py-4">
      <v-layout row align-center style="max-width:680px;">
        <div class="brand-icon"><v-icon color="white">business</v-icon></div>
        <div class="ml-3">
          <div class="eyebrow">Syndawiz</div>
          <div class="title-main headline">Super Syndicate Reporting</div>
        </div>
      </v-layout>
      <v-layout row wrap justify-end align-center class="mt-2">
        <div class="pa-2" style="min-width: 240px;">
          <div class="stat-label mb-1">Syndicate Account</div>
          <v-select
            :items="accountOptions"
            item-text="syndicate_abbreviation"
            item-value="id"
            v-model="selectedAccount"
            @change="onAccountChange"
            solo
            flat
            hide-details
            class="sw-input"
          ></v-select>
        </div>
        <v-chip small color="blue lighten-5" text-color="blue darken-3" class="chip-tight"><v-icon small left>verified_user</v-icon>Permission Based View</v-chip>
        <v-chip small color="grey lighten-3" text-color="blue-grey darken-3" class="chip-tight">Connected to LendWizely</v-chip>
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
import user_helper from '../../helpers/user_helper'

export default {
  mixins: [user_helper],
  data() {
    const sid = localStorage.getItem('syndication_id');
    return {
      selectedAccount: sid === 'all' ? 'all' : parseInt(sid),
    };
  },
  computed: {
    accountOptions() {
      return [{ id: 'all', syndicate_abbreviation: 'All Accounts' }].concat(this.syndicates || []);
    },
  },
  methods: {
    // Switch the selected syndicate in-place (no page reload): update
    // localStorage so a later navigation stays consistent, then tell the parent
    // which refetches the syndicate-specific sections.
    onAccountChange() {
      if (this.selectedAccount === 'all') {
        localStorage.setItem('syndication_id', 'all');
        localStorage.setItem('name', 'All Accounts');
        this.$emit('changed', 'all');
        return;
      }
      const filtered = (this.syndicates || []).filter(o => o.id == this.selectedAccount);
      localStorage.setItem('last_syndication_id', this.selectedAccount);
      localStorage.setItem('syndication_id', this.selectedAccount);
      if (filtered.length) {
        localStorage.setItem('selected_user_id', filtered[0].user_id);
        localStorage.setItem('name', filtered[0].syndicate_name);
      }
      this.$emit('changed', this.selectedAccount);
    },
  },
};
</script>

<style scoped src="./Styles/SuperSyndicate.css"></style>
